import React from 'react'

import SmallButton from 'components/SmallButton'

import * as S from './styles'

const BannerHome = () => {
  return (
    <S.Wrapper>
      <S.WrapperContent>
        <h1>Defy death</h1>
        <p>
          Play the new <span>CrashLands</span> season
        </p>
        <SmallButton>Buy now</SmallButton>
      </S.WrapperContent>
    </S.Wrapper>
  )
}

export default BannerHome
